<div class="modal-header" mat-dialog-title>
    <h5 class="modal-title">Copy Images</h5>
    <a class="modal-close" mat-dialog-close>&#10005;</a>
</div>
<mat-dialog-content class="mat-add-image">
    <div class="modal-body">
        <div class="information d-flex">
            <div class="col-md-6">
                <ul class="ul-list">
                    <li>Check the boxes to select/unselect images</li>
                    <li>Select Anatomic Site Description</li>
                    <li>Click Copy button</li>
                </ul>
            </div>
            <div class="col-md-6">
                <label class="specimen-upload text-right"><strong>Program:</strong> NGC</label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="alert-error" *ngIf="errorList.length > 0">
                    <p *ngFor="let error of errorList" class="error-msg">{{error}}</p>
                </div>
            </div>
            <div class="col-md-8">
                <div class="internal-image-block">
                    <label class="internal-label" *ngIf="dailogData.anatomicSiteCode">From Anatomic Site: {{dailogData.anatomicSiteDesc}} {{dailogData.anatomicSiteCode}}</label>
                    <label class="internal-label" *ngIf="dailogData.caseNumberID">Case #: {{dailogData.caseNumberID}}</label>
                    <table class="table table-striped" aria-describedby="table">
                        <tr>
                            <th scope="col"> <input type="checkbox" name="specimen" value="all" [(ngModel)]="isSelectedAll" (change)="onChangeSpecimen($event, 'all')" /></th>
                            <th scope="col">Description</th>
                            <th scope="col">Diagnosis</th>
                            <th scope="col">Sequence #</th>
                            <th scope="col">Image Source Name</th>
                        </tr>
                        <tr *ngFor="let image of copyImageRows">
                            <td> <input type="checkbox" name="specimen" value="{{image.actionDiagnosis}}" [(ngModel)]="image.isSelected" (change)="onChangeSpecimen($event, image)" /></td>
                            <td>{{image.diagnosis}}</td>
                            <td>{{image.actionDiagnosis}}</td>
                            <td>{{image.sequence}}</td>
                            <td>{{image.name}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col-md-4">
                <ng-container *ngIf="dailogData.anatomicSiteCode">
                    <div class="internal-image-block">
                        <label class="internal-label">To Anatomic Site</label>
                    </div>
                    <div class="anatomic-border">
                        <div class="form-group">
                            <label class="label">Anatomic Site Description:</label>
                            <select class="form-control" [(ngModel)]="selectedAnatomicCode" (change)="onChangeAnatomicSite($event)">
                                <option value="">Select an Anatomic Site</option>
                                <option *ngFor="let site of anatomicSiteDesc" value="{{site.code}}">{{site.description}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="label">Anatomic Site Code:</label>
                            <input class="form-control" type="text" placeholder="Enter Anatomic Site Code" [(ngModel)]="selectedAnatomicCode" readonly>
                            <p class="error" *ngIf="anatomicSiteNoValidation">Enter Valid Anatomic Site #</p>
                        </div>
                        <div class="form-group">
                            <div class="form-group">
                                <label class="label">Diagnosis:</label>
                                <input class="form-control" type="text" [(ngModel)]="matchedDiagnosis.description" readonly>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="label">Diagnosis Code</label>
                            <input class="form-control" type="text" [(ngModel)]="matchedDiagnosis.primaryDiagnosisCode" readonly>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="dailogData.caseNumberID">
                    <div class="internal-image-block">
                        <label class="internal-label">To Case #:</label>
                    </div>
                    <div class="form-group" *ngFor="let mailing of caseRows">
                        <input type="text" class="form-control" [(ngModel)]="mailing.value" (keyup)="onKeyUpMailing($event)" />
                        <p class="error">{{mailing.error}}</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="start">
    <button mat-button class="save-btn" [disabled]="isCopyBtnDisable" (click)="clickCopyImageButton()">Copy</button>
    <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
</mat-dialog-actions>